import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import { useBrand } from '../context/BrandContext'
import s, { colors } from '../styles/theme'
import { GATEABLE_FEATURES } from '../config/features'

const API = process.env.REACT_APP_API_URL || 'http://localhost:3000'
const ALL_KEYS = GATEABLE_FEATURES.map(f => f.key)

function Brands() {
  const [brands, setBrands] = useState([])
  const [loading, setLoading] = useState(true)
  const [showAdd, setShowAdd] = useState(false)
  const [form, setForm] = useState({ name: '', site_url: '', username: '', password: '', tsoft_version: 'os2' })
  const [featuresFor, setFeaturesFor] = useState(null)  // düzenlenen marka id
  const [featForm, setFeatForm] = useState([])           // seçili özellik anahtarları
  const { setSelectedBrand, account } = useBrand()
  const isSuperAdmin = account?.role === 'super_admin'
  const navigate = useNavigate()

  function openFeatures(brand) {
    const ef = Array.isArray(brand.enabled_features) ? brand.enabled_features : ALL_KEYS
    setFeatForm(ef)
    setFeaturesFor(brand.id)
  }

  function toggleFeat(key) {
    setFeatForm(prev => prev.includes(key) ? prev.filter(k => k !== key) : [...prev, key])
  }

  async function saveFeatures(brandId) {
    const token = localStorage.getItem('adminToken')
    // Tümü seçiliyse null gönder (hepsi açık + ileride eklenecek modüller otomatik açık)
    const allSelected = ALL_KEYS.every(k => featForm.includes(k))
    await axios.put(`${API}/admin/brands/${brandId}/features`,
      { enabled_features: allSelected ? null : featForm },
      { headers: { Authorization: token } })
    setFeaturesFor(null)
    fetchBrands()
  }

  function fetchBrands() {
    const token = localStorage.getItem('adminToken')
    axios.get(`${API}/admin/brands`, {
      headers: { Authorization: token }
    }).then(res => {
      setBrands(res.data)
      setLoading(false)
    }).catch(() => setLoading(false))
  }

  useEffect(() => { fetchBrands() }, [])

  async function handleAdd(e) {
    e.preventDefault()
    const token = localStorage.getItem('adminToken')
    await axios.post(`${API}/admin/brands`, form, {
      headers: { Authorization: token }
    })
    setShowAdd(false)
    setForm({ name: '', site_url: '', username: '', password: '', tsoft_version: 'os2' })
    fetchBrands()
  }

  function selectBrand(brand) {
    setSelectedBrand(brand)
    navigate('/')
  }

  async function handleToggle(brand) {
    const token = localStorage.getItem('adminToken')
    await axios.patch(`${API}/admin/brands/${brand.id}/toggle`, {}, {
      headers: { Authorization: token }
    })
    fetchBrands()
  }

  async function handleDelete(brand) {
    if (!window.confirm(`"${brand.name}" markasını silmek istediğinize emin misiniz? Tüm ürünler ve kurallar da silinecek.`)) return
    const token = localStorage.getItem('adminToken')
    await axios.delete(`${API}/admin/brands/${brand.id}`, {
      headers: { Authorization: token }
    })
    fetchBrands()
  }

  if (loading) return <p style={{ color: colors.textSecondary }}>Yükleniyor...</p>

  return (
    <div>
      <div className="sx-wrap" style={{ ...s.flexBetween, marginBottom: '24px', flexWrap: 'wrap', gap: '12px' }}>
        <h2 style={{ ...s.pageTitle, minWidth: 0 }}>Markalar ({brands.length})</h2>
        <button onClick={() => setShowAdd(!showAdd)} style={{ ...(showAdd ? s.btnSecondary : s.btnPrimary), whiteSpace: 'nowrap' }}>+ Yeni Marka</button>
      </div>

      {showAdd && (
        <div style={s.card}>
          <h3 style={{ ...s.sectionTitle, marginBottom: '16px' }}>Yeni Marka Ekle</h3>
          <form onSubmit={handleAdd}>
            <div className="sx-grid-panel" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
              <div>
                <label style={s.labelNormal}>Marka Adı</label>
                <input required value={form.name} onChange={e => setForm({ ...form, name: e.target.value })}
                  style={s.input} />
              </div>
              <div>
                <label style={s.labelNormal}>Site URL</label>
                <input required value={form.site_url} onChange={e => setForm({ ...form, site_url: e.target.value })}
                  placeholder="https://siteadi.com"
                  style={s.input} />
              </div>
              <div>
                <label style={s.labelNormal}>Web Servis Kullanıcı Adı</label>
                <input required value={form.username} onChange={e => setForm({ ...form, username: e.target.value })}
                  style={s.input} />
              </div>
              <div>
                <label style={s.labelNormal}>Web Servis Şifresi</label>
                <input required type="password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })}
                  style={s.input} />
              </div>
              <div>
                <label style={s.labelNormal}>T-Soft Versiyon</label>
                <select value={form.tsoft_version} onChange={e => setForm({ ...form, tsoft_version: e.target.value })}
                  style={s.select}>
                  <option value="os2">T-Soft OS2 (Yeni)</option>
                  <option value="v5">T-Soft V5 (Eski)</option>
                </select>
              </div>
            </div>
            <div className="sx-wrap" style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
              <button type="submit" style={s.btnPrimary}>Kaydet</button>
              <button type="button" onClick={() => setShowAdd(false)} style={s.btnSecondary}>İptal</button>
            </div>
          </form>
        </div>
      )}

      <div style={{ display: 'grid', gap: '12px' }}>
        {brands.map(brand => {
          const featCount = Array.isArray(brand.enabled_features) ? brand.enabled_features.length : ALL_KEYS.length
          const allOpen = featCount === ALL_KEYS.length
          return (
          <div key={brand.id} style={{ ...s.card, marginBottom: 0 }}>
            <div className="sx-wrap" style={{ ...s.flexBetween, flexWrap: 'wrap', gap: '12px' }}>
              <div style={{ minWidth: 0, flex: '1 1 200px' }}>
                <p className="sx-break" style={{ fontWeight: 600, fontSize: '15px', color: colors.textPrimary, marginBottom: '4px' }}>{brand.name}</p>
                <p className="sx-break" style={{ fontSize: '13px', color: colors.textSecondary, marginBottom: '6px' }}>{brand.site_url}</p>
                <span style={brand.tsoft_version === 'os2' ? s.badgeInfo : s.badgeDanger}>
                  {brand.tsoft_version === 'os2' ? 'OS2' : 'V5'}
                </span>
                <span style={{ ...(allOpen ? s.badgeGray : s.badgeWarning), marginLeft: '6px' }}>
                  {allOpen ? 'Tüm modüller' : `${featCount}/${ALL_KEYS.length} modül`}
                </span>
              </div>
              <div className="sx-wrap sx-full-sm" style={{ display: 'flex', gap: '10px', alignItems: 'center', flexShrink: 0, flexWrap: 'wrap' }}>
                <button onClick={() => selectBrand(brand)} style={{ ...s.btnSecondary, fontWeight: '600', whiteSpace: 'nowrap' }}>Seç</button>
                {isSuperAdmin && (
                  <button onClick={() => openFeatures(brand)} style={{ ...s.btnSecondary, whiteSpace: 'nowrap' }}>Özellikler</button>
                )}
                <button onClick={() => handleToggle(brand)} style={{
                  ...s.btn, whiteSpace: 'nowrap',
                  background: brand.is_active ? colors.dangerLight : colors.successLight,
                  color: brand.is_active ? colors.dangerText : colors.successText
                }}>
                  {brand.is_active ? 'Pasife Al' : 'Aktife Al'}
                </button>
                <button onClick={() => handleDelete(brand)} style={{
                  ...s.btn, whiteSpace: 'nowrap', background: colors.dangerLight, color: colors.dangerText
                }}>Sil</button>
              </div>
            </div>

            {featuresFor === brand.id && (
              <div style={{ marginTop: '16px', paddingTop: '16px', borderTop: `1px solid ${colors.border}` }}>
                <p style={{ fontSize: '13px', fontWeight: 600, color: colors.textPrimary, marginBottom: '4px' }}>
                  Alt kullanıcıların görebileceği modüller
                </p>
                <p style={{ ...s.sectionSubtitle, marginBottom: '12px' }}>
                  İşaretli modüller bu markanın brand_admin kullanıcılarının menüsünde görünür. (Dashboard, Setup her zaman açıktır.)
                </p>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '8px', marginBottom: '16px' }}>
                  {GATEABLE_FEATURES.map(f => (
                    <label key={f.key} className="sx-break" style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', cursor: 'pointer', color: colors.textPrimary, minWidth: 0 }}>
                      <input type="checkbox" checked={featForm.includes(f.key)} onChange={() => toggleFeat(f.key)} style={{ flexShrink: 0 }} />
                      {f.label}
                    </label>
                  ))}
                </div>
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
                  <button onClick={() => saveFeatures(brand.id)} style={s.btnPrimary}>Kaydet</button>
                  <button onClick={() => setFeatForm(ALL_KEYS)} style={s.btnSecondary}>Tümünü Seç</button>
                  <button onClick={() => setFeatForm([])} style={s.btnSecondary}>Hiçbiri</button>
                  <button onClick={() => setFeaturesFor(null)} style={s.btnGhost}>Kapat</button>
                  <span style={{ fontSize: '12px', color: colors.textSecondary, marginLeft: 'auto' }}>{featForm.length}/{ALL_KEYS.length} seçili</span>
                </div>
              </div>
            )}
          </div>
          )
        })}
      </div>
    </div>
  )
}

export default Brands
